import { useEffect, useState} from 'react';
import Template from '../Template'
import * as SG from '../../style/Styles'
import * as TXT from './../../util/Texts'
import * as F from './../../util/Functions'
import * as UserService from './../../services/User.service'
import { ERROR_ALERT, SUCCESS_ALERT } from './../../util/AlertsMsg'

interface ChangePass {
  id:string,
  password:string
}

export default function MyProfile() {

  const [password, setPassword]               = useState<string>('')
  const [confirmPassword, setConfirmPassword] = useState<string>('')
  const [name, setName]                       = useState<string>('')
  const [department, setDepartment]           = useState<string>('')
  const [cs, setCs]                           = useState<string>('')
  const [typeInp, setTypeInp]                 = useState<string>('password')
  const [iconPass, setIconPass]               = useState<string>('fa-eye')
  const [typeInp2, setTypeInp2]               = useState<string>('password')
  const [iconPass2, setIconPass2]             = useState<string>('fa-eye')

  const [countries, setCountries]             = useState<any[]>([])
  const [countryId, setCountryId]             = useState<string | number>('')

  const handleSend = async () => {

    if (password.trim() === '' || confirmPassword.trim() === '') {
      ERROR_ALERT(TXT.EMPTY_PASS)
      return false
    }

    if (password.trim() !== confirmPassword.trim()) {
      ERROR_ALERT(TXT.WRONG_CONFIRM_PASS)
      return false
    }

    if (password.trim() === F.GetRegister()) {
      ERROR_ALERT(TXT.CANT_SAME_REG)
      setPassword('')
      setConfirmPassword('')
      return false
    }

    try {

      const data:ChangePass = {id:F.GetIDUser(), password: password.trim()}
      const result          = await UserService.ChangePassword(data, null)

      if (result.data) {
        if (result.status === 200)
          SUCCESS_ALERT(result.data.message)
        else
          ERROR_ALERT(result.data.message)
          setTimeout(()=>{
            window.location.reload()
          },3000)
      } 

    } catch (error) {
      console.warn(error)
      ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
    }
    
    return true
  }

  const handleSaveCountry = async () => {
    try {
      const data = {
        id: F.GetIDUser(),
        country_id: countryId === '' ? null : Number(countryId)
      }
      const result = await UserService.UpdateCountry(data)
      if (result && result.data) {
        if (result.status === 200 || result.data.status) {
          SUCCESS_ALERT(result.data.message || 'País atualizado com sucesso!')
          localStorage.setItem('us_country_id', countryId.toString())
        } else {
          ERROR_ALERT(result.data.message || TXT.WRONG_TRY_AGAIN)
        }
      } else {
        ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
      }
    } catch (error) {
      console.warn(error)
      ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
    }
  }

  const openEye = (t:number) => {

    if ( t === 1 ) {
      setIconPass(iconPass === 'fa-eye-slash' ? 'fa-eye' : 'fa-eye-slash')
      setTypeInp(typeInp === 'password' ? 'text' : 'password')
    } else {
      setIconPass2(iconPass2 === 'fa-eye-slash' ? 'fa-eye' : 'fa-eye-slash')
      setTypeInp2(typeInp2 === 'password' ? 'text' : 'password')
    }

  }

  const getDataUser = ()=>{

    setName(localStorage.getItem('us_nm')??'')
    setDepartment(localStorage.getItem('us_dpt')??'')
    setCs(localStorage.getItem('us_cs')??'')

    const userCountry = localStorage.getItem('us_country_id') ?? ''
    setCountryId(userCountry)

    const storedCountries = localStorage.getItem('app_countries')
    if (storedCountries) {
      setCountries(JSON.parse(storedCountries))
    }

    return
  }

  useEffect(() => {

    getDataUser()

  }, [])
  

  return (
    <Template>

      <SG.Title className='title'>{TXT.MY_PROFILE}</SG.Title>

      <SG.PADD>
        <SG.Flex className='FatboxProfile'>
          <SG.BoxGrey className='boxProfile'>
            <SG.PADD style={{padding:30}}>

              <SG.SmallTitle>{TXT.NAME}</SG.SmallTitle>
              <SG.DisableText>{name}</SG.DisableText>

              <SG.SmallTitle>{TXT.DEPARTMENT}</SG.SmallTitle>
              <SG.DisableText>{department}</SG.DisableText>

              <SG.SmallTitle>{TXT.PLANT}</SG.SmallTitle>
              <SG.DisableText>{cs}</SG.DisableText>

              <SG.SmallTitle>{TXT.COUNTRY}</SG.SmallTitle>
              <SG.SelectInternal
                value={countryId}
                onChange={(e) => setCountryId(e.target.value)}
                style={{ maxWidth: '500px', margin: '10px 0' }}
                disabled={F.GetUserType() === 3}
              >
                <option value="">{TXT.SELECT_YOUR_COUNTRY}...</option>
                {countries.map((country) => (
                  <option key={country.id} value={country.id}>
                    {country.name}
                  </option>
                ))}
              </SG.SelectInternal>

              {F.GetUserType() !== 3 && (
                <SG.PrimaryButtom
                  className='PrimaryButtomProf'
                  style={{ margin: '15px 0', width: '220px', height: '45px', fontSize: '16px' }}
                  onClick={handleSaveCountry}
                >
                  {TXT.SAVE_COUNTRY}
                </SG.PrimaryButtom>
              )}
            </SG.PADD>

          </SG.BoxGrey>

          <SG.BoxGrey className='boxProfile'>
            <SG.PADD style={{padding:30}}>

              <SG.SmallTitle style={{width:'90%', margin:'0 auto'}}>{TXT.CHANGE_PASS}</SG.SmallTitle>

              <SG.Div style={{display:'flex'}}>
              <SG.InputInternal 
                type={typeInp}
                name='password'
                value={password}
                placeholder={TXT.NEW_PASS}
                onChange={(e) => {setPassword(e.target.value)}}
              />
              <SG.Span className='IconPassInt'  onClick={()=>{openEye(1)}}><i className={`fa-solid ${iconPass}`}></i></SG.Span> 
              </SG.Div>

              <SG.Div style={{display:'flex'}}>
              <SG.InputInternal 
                type={typeInp2}
                name='ConfirmPassword'
                value={confirmPassword}
                placeholder={TXT.CONFIRM_PASS}
                onChange={(e) => { setConfirmPassword(e.target.value)}}
              />
               <SG.Span className='IconPassInt' onClick={()=>{openEye(2)}}><i className={`fa-solid ${iconPass2}`}></i></SG.Span> 
              </SG.Div>

              <SG.PrimaryButtom
                className='PrimaryButtomProf'
                style={{margin:'5px 20px'}}
                onClick={handleSend}
              >
                {TXT.RESET_PASS}
              </SG.PrimaryButtom>

            </SG.PADD>
          </SG.BoxGrey>
        </SG.Flex>
      </SG.PADD>
    </Template>
  );
}
  
 
  